import React from 'react'; 
import {getIncidents} from '../utils/realtimeEventHandle'
import QualdoDataTable from '../components/bootstrapTable';
import Load from '../components/loadAction';
// import Image from "../components/image"
import {LIST_VIEW_OPTIONS} from "../utils/constant";
import $ from 'jquery';
// let incidentData = {"incident_details": [
// {
//   "generated_at": "2025-01-16 15:46:26",
//   "id": 61298,
//   "is_child": true,
//   "metrics_details": [
//     {
//       "condition": "<",
//       "metrics_id": 48622,
//       "metrics_name": "Fill Rate ",
//       "threshold": 80.0,
//       "value": 60.0
//     },
//     {
//       "condition": ">",
//       "metrics_id": 48623,
//       "metrics_name": "Row Count ",
//       "threshold": 30.0,
//       "value": 0
//     }
//   ],
//   "name": "cpu_usage_date15.csv",
//   "source": [
//     {
//       "integration_id": 3721,
//       "integration_name": "Start data"
//     }
//   ],
//   "type": 1
// },
// {
//   "generated_at": "2025-01-16 15:46:26",
//   "id": 377388,
//   "is_child": false,
//   "metrics_details": [
//     {
//       "condition": "<",
//       "metrics_id": 48622,
//       "metrics_name": null,
//       "threshold": 80.0,
//       "value": 0.0
//     }
//   ],
//   "name": "overhead_latency",
//   "source": [
//     {
//       "integration_id": 3721,
//       "integration_name": "Start data"
//     },
//     {
//       "data_set_id": 61298,
//       "data_set_name": "cpu_usage_date15.csv"
//     }
//   ],
//   "type": 2
// },
// {
//   "generated_at": "2025-01-16 15:46:26",
//   "id": 377393,
//   "is_child": false,
//   "metrics_details": [
//     {
//       "condition": "<",
//       "metrics_id": 48622,
//       "metrics_name": null,
//       "threshold": 80.0,
//       "value": 0.0
//     }
//   ],
//   "name": "memory_usage",
//   "source": [
//     {
//       "integration_id": 3721,
//       "integration_name": "Start data"
//     },
//     {
//       "data_set_id": 61298,
//       "data_set_name": "cpu_usage_date15.csv"
//     }
//   ],
//   "type": 2
// }
// ]}
export default class DQIncidentGrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      incidentTableData:"",
      incidentTableFilterData:"",
      selectedGroup:"",
      showpartitions:true,
      incidentData : this.props.incidentData
    }

    this.formatTableData   = this.formatTableData.bind(this)
    this.changePartitions  = this.changePartitions.bind(this)
    this.changeGroup       = this.changeGroup.bind(this)
    this.loadIncidentData  = this.loadIncidentData.bind(this)
  }



  async loadIncidentData(){
   let data_response = {};

if (this.props.incidentData !== null) {
  const prevIncidents =
    this.state.incidentTableData ||
    this.state.incident?.response?.[0]?.incident_details ||
    [];
  const latestIncidents = this.normalizeIncidentDetails(this.props.incidentData);
  const existingIncidents = this.normalizeIncidentDetails(prevIncidents);

  data_response = {
    message: "Successfully fetched",
    code: 200,
    response: [
      {
        incident_details: this.mergeIncidentLists(latestIncidents, existingIncidents)
      }
    ]
  };
} else {
  data_response = await this.getIncidentsResponse();

  // CLIENT-SIDE WATCHLIST FILTERING
  if (this.props.selectedWatchListId && data_response.code === 200) {
    const watchlistData = this.getWatchlistAttributeIds();
    
    if (watchlistData.attributeIds.length > 0) {
      const allIncidents = data_response.response[0].incident_details;
      
      // Filter incidents to only include those related to watchlist attributes
      const filteredIncidents = allIncidents.filter(incident => {
        // Include attribute-level incidents (type 2) if they're in the watchlist
        if (incident.type === 2) {
          return watchlistData.attributeIds.includes(incident.id);
        }
        
        // Include dataset-level incidents (type 1) - be more inclusive
        if (incident.type === 1) {
          // For now, include ALL dataset-level incidents to ensure they show up
          // You can fine-tune this logic later based on your specific needs
          return true;
        }
        
        return false;
      });
      
      data_response.response[0].incident_details = filteredIncidents;
    }
  }
}

    if(data_response.code===200){
    const incidentDetails = this.normalizeIncidentDetails(data_response.response?.[0]?.incident_details || data_response.response?.[0]?.incident_list || []);
    this.setState({incidentResponseData: data_response,incident:data_response})
    let data1 = this.formatTableData(incidentDetails)
    this.setState({incidentTableData:incidentDetails,incidentTableFilterData:data1,incidentResponseData:data1})
    }else{
      let data1 = this.formatTableData([])
      this.setState({incidentTableData:[],incidentTableFilterData:data1,incidentResponseData:data1})
    }
  }

  normalizeIncidentDetails(incidents = []) {
    if (!Array.isArray(incidents)) {
      return [];
    }

    return incidents.filter(Boolean).map((incident) => {
      if (!incident) {
        return incident;
      }

      return {
        ...incident,
        metrics_details: Array.isArray(incident.metrics_details) ? incident.metrics_details : [],
        source: Array.isArray(incident.source) ? incident.source : (incident.source ? [incident.source] : [])
      };
    });
  }

  mergeIncidentLists(newIncidents = [], existingIncidents = []) {
    const mergedIncidents = [];
    const seenIncidents = new Set();

    [...newIncidents, ...existingIncidents].forEach((incident) => {
      if (!incident) {
        return;
      }

      const metricIds = Array.isArray(incident.metrics_details)
        ? incident.metrics_details.map(metric => metric?.metrics_id).join(",")
        : "";
      const incidentKey = [incident.type, incident.id, incident.generated_at, metricIds].join("|");

      if (!seenIncidents.has(incidentKey)) {
        seenIncidents.add(incidentKey);
        mergedIncidents.push(incident);
      }
    });

    return mergedIncidents;
  }

  // Helper method to get watchlist attribute IDs from parent component
  getWatchlistAttributeIds() {
    // Get watchlist data from props (passed from parent component)
    if (!this.props.selectedWatchListId || !this.props.watchlistData) {
      return { attributeIds: [], attributeNames: [] };
    }
    
    const selectedWatchlist = this.props.watchlistData.find(
      w => w.watch_list_id === this.props.selectedWatchListId
    );
    
    if (selectedWatchlist && selectedWatchlist.watch_list_data && selectedWatchlist.watch_list_data.attributes) {
      const attributeIds = [];
      const attributeNames = [];
      
      Object.values(selectedWatchlist.watch_list_data.attributes).forEach(attrArray => {
        attrArray.forEach(attr => {
          if (attr.value) {
            attributeIds.push(attr.value);
          }
          if (attr.label) {
            attributeNames.push(attr.label.toLowerCase());
          }
        });
      });
      
      return { attributeIds, attributeNames };
    }
    
    return { attributeIds: [], attributeNames: [] };
  }

  changePartitions() {
    let filterData;  
    let showpartitions = !this.state.showpartitions;
    if(showpartitions === true){
      if(this.state.selectedGroup.value==="all"){
        filterData = this.state.incidentTableData;
      }
      else if(this.state.selectedGroup.value==="datasets"){
        filterData = this.state.incidentTableData.filter((incident) => incident.type ===1) ;
      }
      else if(this.state.selectedGroup.value==="attributes"){
        filterData = this.state.incidentTableData.filter((incident) => incident.type ===2) ;
      }
      else{
        filterData = this.state.incidentTableData;
      }
    }else {
      if(this.state.selectedGroup==="" ){
        filterData = this.state.incidentTableData.filter((incident) =>  incident.is_child===false) ;
      }
      else if(this.state.selectedGroup.value==="all" ){
        filterData = this.state.incidentTableData.filter((incident) =>  incident.is_child===false ) ;
      }
      else if(this.state.selectedGroup.value==="datasets"){
        filterData = this.state.incidentTableData.filter((incident) =>  incident.is_child===false && incident.type === 1) ;
      }
      else if(this.state.selectedGroup.value==="attributes"){
        filterData = this.state.incidentTableData.filter((incident) =>  incident.is_child===false && incident.type ===2) ;
      }
    }
    this.setState({
      showpartitions:showpartitions,
      incidentTableFilterData:this.formatTableData(filterData)
    });
  }

  changeGroup(selectedOption) {
      let filterData;  
      if(selectedOption.value==="all" && this.state.showpartitions === true){
        filterData = this.state.incidentTableData;
      }
      else if(selectedOption.value==="datasets" && this.state.showpartitions === true){
        filterData = this.state.incidentTableData.filter((incident) =>  incident.type ===1) ;
      }
      else if(selectedOption.value==="attributes" && this.state.showpartitions === true){
        filterData = this.state.incidentTableData.filter((incident) =>  incident.type ===2) ;
      }
      else if(selectedOption.value==="all" && this.state.showpartitions === false){
        filterData = this.state.incidentTableData.filter((incident) => incident.is_child===false);
      }
      else if(selectedOption.value==="datasets" && this.state.showpartitions === false){
        filterData = this.state.incidentTableData.filter((incident) => incident.is_child===false  && incident.type ===1) ;
      }
      else if(selectedOption.value==="attributes" && this.state.showpartitions === false){
        filterData = this.state.incidentTableData.filter((incident) => incident.is_child===false  && incident.type ===2) ;
      }
    this.setState({
      selectedGroup: selectedOption,
      changeGroup:true,
      incidentTableFilterData:this.formatTableData(filterData)
    });
  }

  getIncidentsResponse(){
    let requestParams = 
    {
      "tenant_id":this.props.teamId,
      "env_id":this.props.selectedEnvId,
      //"start_date" : this.props.incidentStartDate,
      //"end_date": this.props.incidentEndDate,
     "integration_id":this.props.integrationId,
      // "start_date":"2025-01-01",
      // "end_date": "2025-01-31",
      "user_id":this.props.userId,
      "data_set_id": this.props.selectedDatasetId,
      "current_page" :1,
      "page_per_record" :100,
      "top_issues" : 100,
      "watchlist_id" : this.props.selectedWatchListId || null,
      "type" : "DQ",
      "start_date": this.props.incidentStartDate,
      "end_date": this.props.incidentEndDate
    }
    if (this.props.selectedDate) {
    requestParams.date = this.props.selectedDate;
    requestParams.start_date = this.props.selectedDate;
    requestParams.end_date = this.props.selectedDate;
    } else {
    requestParams.start_date = this.props.incidentStartDate;
    requestParams.end_date = this.props.incidentEndDate;
    }
    return getIncidents(requestParams);
    /*return {
      "code":200,
      "message":"Successfully updated",
      response: [
        {
          "data_set_id": 61298,
          "incident_details": [
            {
              "generated_at": "2025-01-16 15:46:26",
              "id": 61298,
              "is_child": false,
              "metrics_details": [
                {
                  "condition": "<",
                  "metrics_id": 48622,
                  "metrics_name": "Fill Rate ",
                  "threshold": 80.0,
                  "value": 60.0
                },
                {
                  "condition": ">",
                  "metrics_id": 48623,
                  "metrics_name": "Row Count ",
                  "threshold": 30.0,
                  "value": 0
                },
                {
                  "condition": "<",
                  "metrics_id": 48622,
                  "metrics_name": "Fill Rate ",
                  "threshold": 80.0,
                  "value": 60.0
                },
                {
                  "condition": ">",
                  "metrics_id": 48623,
                  "metrics_name": "Row Count ",
                  "threshold": 30.0,
                  "value": 0
                },
                {
                  "condition": "<",
                  "metrics_id": 48622,
                  "metrics_name": "Fill Rate ",
                  "threshold": 80.0,
                  "value": 60.0
                },
                {
                  "condition": ">",
                  "metrics_id": 48623,
                  "metrics_name": "Row Count ",
                  "threshold": 30.0,
                  "value": 0
                },
                {
                  "condition": "<",
                  "metrics_id": 48622,
                  "metrics_name": "Fill Rate ",
                  "threshold": 80.0,
                  "value": 60.0
                },
                {
                  "condition": ">",
                  "metrics_id": 48623,
                  "metrics_name": "Row Count ",
                  "threshold": 30.0,
                  "value": 0
                }
                
              ],
              "name": "cpu_usage_date15.csv",
              "source": [
                {
                  "integration_id": 3721,
                  "integration_name": "Start data"
                }
              ],
              "type": 1
            },
            {
              "generated_at": "2025-01-16 15:46:26",
              "id": 377388,
              "is_child": false,
              "metrics_details": [
                {
                  "condition": "<",
                  "metrics_id": 48622,
                  "metrics_name": null,
                  "threshold": 80.0,
                  "value": 0.0
                }
              ],
              "name": "overhead_latency",
              "source": [
                {
                  "integration_id": 3721,
                  "integration_name": "Start data"
                },
                {
                  "data_set_id": 61298,
                  "data_set_name": "cpu_usage_date15.csv"
                }
              ],
              "type": 2
            },
            {
              "generated_at": "2025-01-16 15:46:26",
              "id": 377393,
              "is_child": false,
              "metrics_details": [
                {
                  "condition": "<",
                  "metrics_id": 48622,
                  "metrics_name": null,
                  "threshold": 80.0,
                  "value": 0.0
                }
              ],
              "name": "memory_usage",
              "source": [
                {
                  "integration_id": 3721,
                  "integration_name": "Start data"
                },
                {
                  "data_set_id": 61298,
                  "data_set_name": "cpu_usage_date15.csv"
                }
              ],
              "type": 2
            }
          ]
        }
      ]}*/
      
  }


shouldComponentUpdate(nextProps, nextState) {
  if (
    nextProps.selectedDatasetId !== this.props.selectedDatasetId ||
    nextProps.incidentStartDate !== this.props.incidentStartDate ||
    nextProps.incidentEndDate !== this.props.incidentEndDate ||
    nextProps.selectedWatchListId !== this.props.selectedWatchListId ||
    (nextProps.incidentData !== null && JSON.stringify(nextProps.incidentData) !== JSON.stringify(this.props.incidentData)) ||
    nextState.incidentTableData !== this.state.incidentTableData ||
    nextState.incidentTableFilterData !== this.state.incidentTableFilterData ||
    nextState.showpartitions !== this.state.showpartitions
  ) {
    return true; // allow re-render
  }
  return false; // prevent unnecessary re-render
}

  formatTableData(data = []) {
    let headers = ["Name", "Alert/Notifications", "Generated at" , "Source"];
    let tempdata = Array.isArray(data) ? data : [];
    let finalOpt = [];
    let today = new Date();
    let yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    // function formatDateTime_old(dateStr) {
    //     let dateObj = new Date(dateStr);
    //     let hours = String(dateObj.getUTCHours()).padStart(2, '0');
    //     let minutes = String(dateObj.getUTCMinutes()).padStart(2, '0');
    //     let seconds = String(dateObj.getUTCSeconds()).padStart(2, '0');
    //     let timeGMT = `${hours}:${minutes}:${seconds} GMT`;

    //     let dateLabel;
    //     if (dateObj.toDateString() === today.toDateString()) {
    //         dateLabel = "Today";
    //     } else if (dateObj.toDateString() === yesterday.toDateString()) {
    //         dateLabel = "Yesterday";
    //     } else {
    //         dateLabel = dateObj.toISOString().split('T')[0]; 
    //     }
    //     return ` ${dateLabel} ${timeGMT} `;
    // }

    function formatDateTime(dateStr) {
      const dateObj = new Date(dateStr);

      const hours = String(dateObj.getUTCHours()).padStart(2, '0');
      const minutes = String(dateObj.getUTCMinutes()).padStart(2, '0');
      const seconds = String(dateObj.getUTCSeconds()).padStart(2, '0');

      const time = `${hours}:${minutes}:${seconds} GMT`;

      let dateLabel;
      if (dateObj.toDateString() === today.toDateString()) {
        dateLabel = 'Today';
      } else if (dateObj.toDateString() === yesterday.toDateString()) {
        dateLabel = 'Yesterday';
      } else {
        dateLabel = dateObj.toLocaleDateString('en-CA'); // YYYY-MM-DD
      }

      return `${dateLabel} ${time}`;
    }

    
    for (let i in tempdata) {
        let row = [];
        const source = tempdata[i]["source"];
        const src = Array.isArray(source) ? (source[0] || {}) : (source || {});
        row.push({
          "value": {
            ...tempdata[i],
            source: [{
              integration_name: src.integration_name,
              integration_id: src.integration_id,
              env_id: src.env_id,
              data_set_id: src.data_set_id,
              data_set_name: src.data_set_name
            }]
          },
          "type": "component"
        });
        row.push({"value": tempdata[i]["metrics_details"], "type": "component"})
        row.push({"value": formatDateTime(tempdata[i]["generated_at"]), "type": "td"})
        row.push({
          "value": [{ 
            integration_name: src.integration_name,
            integration_id: src.integration_id,
            env_id: src.env_id,
            data_set_id: src.data_set_id
          }],
          "type": "td"
        });
        finalOpt.push(row);
    }
    let tableData = {"headers": headers, "data": finalOpt};
    return tableData;
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevProps.selectedDatasetId !== this.props.selectedDatasetId || prevProps.incidentEndDate !== this.props.incidentEndDate || prevProps.incidentStartDate !== this.props.incidentStartDate || prevProps.selectedWatchListId !== this.props.selectedWatchListId) {
      this.loadIncidentData()
    }

    if(this.props.incidentData !== null && JSON.stringify(prevProps.incidentData) !== JSON.stringify(this.props.incidentData)){
      this.loadIncidentData()
    }
     if (prevProps.dataType !== this.props.dataType) {
        this.toggleIncidentGridView();

  }
  } 

  async componentDidMount() {
    this.loadIncidentData(this.state.incidentData)
    this.observeIncidentGridView();

  }
  observeIncidentGridView = () => {
  const observer = new MutationObserver(() => {
    const $el = $("#incidentgridview");

    if ($el.length) {
      this.toggleIncidentGridView();
      observer.disconnect(); // stop once found
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
};

toggleIncidentGridView = () => {
  const $el = $("#incidentgridview");
  if (!$el.length) return;

  if (this.props.dataType === "Dataset" || this.props.dataType === "Attribute") {
    $el.show();
  } else {
    $el.hide();
  }
};
 render() {
const { incidentTableFilterData } = this.state;
const {selectedDatasetAttrId,selectedMetricsId,selectedDatasetId,selectedMeticsName} = this.props;
const selectedGroupValue = this.state.selectedGroup?.value;

let filteredData = { headers: incidentTableFilterData?.headers || [], data: [] };

if (incidentTableFilterData?.data) {
if (
  selectedDatasetAttrId &&
  selectedDatasetId &&
  selectedMetricsId &&
  selectedMeticsName && this.props.dataType === "Attribute"
) {
  const [metricType, metricIdString] = selectedMetricsId.split("_");
  const metricIdNumber = Number(metricIdString);

  filteredData = {
    headers: incidentTableFilterData.headers,
    data: incidentTableFilterData.data
      .filter((row) => {
        const row0 = row[0]?.value;
        const metricsArr = row[1]?.value;

        if (!row0 || !metricsArr) return false;
        let matchesRowId = false;

        if (metricType === "dataset") {
          matchesRowId = Number(row0.id) === Number(selectedDatasetId);
        }

        if (metricType === "attribute") {
          matchesRowId = Number(row0.id) === Number(selectedDatasetAttrId);
        }

        if (!matchesRowId) return false;
        return metricsArr.some(
          (metric) => Number(metric.metrics_id) === metricIdNumber
        );
      })
      .map((row) => {
        row[1].value = row[1].value.filter(
          (metric) => Number(metric.metrics_id) === metricIdNumber
        );        
        return row;
      }),
  };
}

else if (selectedDatasetAttrId && selectedDatasetId && selectedMetricsId && selectedMeticsName) {
   const [metricType, metricIdString] = selectedMetricsId.split("_");
  const metricIdNumber = Number(metricIdString);

  filteredData = {
    headers: incidentTableFilterData.headers,
    data: incidentTableFilterData.data
      .filter((row) => {
        const row0 = row[0]?.value;
        const metricsArr = row[1]?.value;

        if (!row0 || !metricsArr) return false;
        let matchesRowId = false;

        if (metricType === "dataset") {
          matchesRowId = Number(row0.id) === Number(selectedDatasetId);
        }

        if (metricType === "attribute") {
          matchesRowId = Number(row0.id) === Number(selectedDatasetAttrId);
        }

        if (!matchesRowId) return false;
        return metricsArr.some(
          (metric) => Number(metric.metrics_id) === metricIdNumber
        );
      })
      .map((row) => {
        row[1].value = row[1].value.filter(
          (metric) => Number(metric.metrics_id) === metricIdNumber
        );        
        return row;
      }),
  };
}


 else if (selectedDatasetAttrId && this.props.dataType === "Attribute") {
    filteredData = {
      headers: incidentTableFilterData.headers,
      data: incidentTableFilterData.data.filter((row) => {
        const attributeComponent = row[0];
        return Number(attributeComponent?.value?.id) === Number(selectedDatasetAttrId);
      }),
    };
  } 
  else if (selectedDatasetId && selectedMetricsId) {    
    const [metricType, metricIdString] = selectedMetricsId.split("_");
  const metricIdNumber = Number(metricIdString);
    filteredData = {
    headers: incidentTableFilterData.headers,
    data: incidentTableFilterData.data
      .filter((row) => {
        const row0 = row[0]?.value;
        const metricsArr = row[1]?.value;

        if (!row0 || !metricsArr) return false;
        let matchesRowId = false;

        if (metricType === "dataset") {
          matchesRowId = Number(row0.id) === Number(selectedDatasetId);
        }

        // if (metricType === "attribute") {
        //   matchesRowId = Number(row0.id) === Number(selectedDatasetAttrId);
        // }

      if (!matchesRowId) return false;

if (!Array.isArray(metricsArr)) return false;

return metricsArr.some(
  (metric) => Number(metric.metrics_id) === metricIdNumber
);

      })
      .map((row) => {
        row[1].value = row[1].value.filter(
          (metric) => Number(metric.metrics_id) === metricIdNumber
        );        
        return row;
      }),
  };
  }
  else if (selectedDatasetId) {
    // 🔹 Dataset only
    filteredData = {
      headers: incidentTableFilterData.headers,
      data: incidentTableFilterData.data.filter((row) => {
        const datasetComponent = row[0];
        return Number(datasetComponent?.value?.id) === Number(selectedDatasetId);
      }),
    };
  } 
  else if (selectedMetricsId && this.props.dataType === "Attribute") {
    // 🔹 Metrics only
    filteredData = {
      headers: incidentTableFilterData.headers,
      data: incidentTableFilterData.data.filter((row) => {
        const metricComponent = row[1];
        const metricArray = metricComponent?.value;
       const attr = row[0];

      return (       
          Number(attr?.value?.id) === Number(selectedDatasetAttrId) &&
          Array.isArray(metricArray) &&
          metricArray.some(metric => metric?.metrics_id === selectedMetricsId &&  metric?.metrics_name === selectedMeticsName)
        );
      }),
    };
  } 
  else {
    filteredData = incidentTableFilterData;
  }
}
if (
  selectedGroupValue === "all" ||
  (
    this.state.changeGroup &&
    !selectedDatasetAttrId &&
    !selectedDatasetId &&
    !selectedMetricsId
  )
) {
  console.log("Dataset + Attribute view - showing all rows");
  filteredData = incidentTableFilterData;
}

  return (
    <>
      {!incidentTableFilterData?.data ? (
        <Load />
      ):(
      <QualdoDataTable
        id="dqincidentgrid"
        data={filteredData}
        component_name="dqincidentgrid"
        selectedGroup={this.state.selectedGroup ? this.state.selectedGroup : LIST_VIEW_OPTIONS[1] }
        showpartitions={this.state.showpartitions}
        changePartitions={this.changePartitions}
        pageListRenderer={0}
        paginationSize={5}
        changeGroup={this.changeGroup}
        focusChart={this.props.focusChart}
      />  )}
      </>
    );
  }
}
